import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ActionButton = styled(Button)(({ theme }) => ({
  marginTop: 10,
  backgroundColor: theme.palette.dialog.primaryButton.background,
  height: 50,
  width: '100%',
  color: theme.palette.dialog.primaryButton.color,
  '&:hover': {
    backgroundColor: theme.palette.dialog.primaryButton.backgroundHover,
  },
}));

export const DialogTitleStyled = styled(DialogTitle)(({ theme }) => ({
  padding: '20px 50px 20px 20px',
  [theme.breakpoints.down('sm')]: {
    padding: '10px 50px 10px 10px',
  },
}));

export const DialogContentRoot = styled(DialogContent)(({ theme }) => ({
  padding: '0px 20px 0px 20px',
  backgroundColor: 'white',
  [theme.breakpoints.down('sm')]: {
    padding: '0px 10px 0px 10px',
  },
}));

export const DialogActionRoot = styled(DialogActions)(({ theme }) => ({
  padding: '20px',
  [theme.breakpoints.down('sm')]: {
    padding: '10px 10px 15px 10px',
  },
  backgroundColor: 'white',
  '& button': {
    borderRadius: '15px',
  },
}));
